"use client";

/**
 * /login — the front door's sign-in, in the new landing's room (spec
 * 2026-10-17-waitlist-front-door). Every sign-up button on the landing lands
 * here. After Google the auth callback routes by who you are: onboarded
 * users go home, everyone else to /waitlist (which forwards the approved).
 */

import { SignIn } from "@/components/front-door/SignIn";

export default function LoginPage() {
  return <SignIn />;
}
